import { useLargeFromMediaQuery } from '@madpaws/design-system';

import { ExpandedSearchFiltersForm } from '~/components/SearchFiltersForm/ExpandedSearchFilterForm/ExpandedSearchFiltersForm';
import { SearchFiltersForm } from '~/components/SearchFiltersForm/SearchFiltersForm/SearchFiltersForm';

import styles from './DesktopSearchWidgetWrapper.module.css';

import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

type Props = {
  handleFiltersSave: (searchFilters: SearchFilters) => void;
  isExpandedSearchFiltersEnabled?: boolean;
  searchFilters: SearchFilters;
};

export const DesktopSearchWidgetWrapper = ({
  handleFiltersSave,
  searchFilters,
  isExpandedSearchFiltersEnabled = false,
}: Props): ReactElement | null => {
  const isLargeFromViewport = useLargeFromMediaQuery();

  if (!isLargeFromViewport) {
    return null;
  }

  if (isExpandedSearchFiltersEnabled) {
    return (
      <div className={styles.root}>
        <ExpandedSearchFiltersForm
          currentValues={searchFilters}
          onFilterSubmit={handleFiltersSave}
        />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <SearchFiltersForm currentValues={searchFilters} onFilterSubmit={handleFiltersSave} />
    </div>
  );
};
